export default __webpack_public_path__ + "static/jiri-pixa-b18660fb683b74a71fb1a8cb1cedf177.jpg";